import React, { Component } from 'react';
import Slider from "react-slick";

function SliderNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img className={className} style={{ ...style }} src="/img/icon_arrow_right.png" onClick={onClick} />
    );
  }

function SliderPrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img className={className} style={{ ...style, marginLeft: 0, }} src="/img/icon_arrow_left.png" onClick={onClick} />
    );
}

class Home extends Component {
    constructor () {
        super();
        this.state = {
            numberRedApply: 0,
            numberWaitForEvalApply: 0,
            numberNewMsgApply: 0,
            slides: [
                {image: '/img/houjin-sliders/sevenbunner0528.jpg', link: 'https://www.sevenbank.co.jp/personal/account/?utm_source=app&utm_medium=banner&utm_campaign=entry_202105'},
                // {image: '/img/houjin-sliders/bunner_sample2.png', link: 'https://ja.wikipedia.org/wiki/2'},
                // {image: '/img/houjin-sliders/bunner_sample3.png', link: 'https://ja.wikipedia.org/wiki/3'},
                // {image: '/img/houjin-sliders/bunner_sample4.png', link: 'https://ja.wikipedia.org/wiki/4'},
                // {image: '/img/houjin-sliders/bunner_sample5.png', link: 'https://ja.wikipedia.org/wiki/5'},
            ]
        };
        this.fireRedirect = this.fireRedirect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    componentDidMount () {
        //Count red job apply
        axios.get('/api/houjin/jobapplys/count_red').then(response => {
            this.setState({
                numberRedApply: response.data.newApply,
                numberWaitForEvalApply: response.data.waitForEvalApply,
                numberNewMsgApply: response.data.newMsgApply
            });
        });
    }

    handleRedirect(url) {
        this.props.history.push(url);
    }

    fireRedirect(e) {
        e.preventDefault()
        this.handleRedirect(e.currentTarget.getAttribute('href'));
        $('[data-toggle="tooltip"]').tooltip('hide');
    }

    /**
     * Handle hover image
     */
    onHoverTooltip() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    _renderTopSliders() {
        const settings = {
            className: "row mx-4",
            dots: false,
            infinite: false,
            swipeToSlide: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            nextArrow: <SliderNextArrow />,
            prevArrow: <SliderPrevArrow />,
        };
        let list = this.state.slides.sort(() => Math.random() - 0.5)

        return (
            <Slider {...settings}>
                {list.map(function(slide) {
                    return (
                        <div key={slide} className="px-2">
                            <a href={slide.link} key={slide} target="_blank">
                                <img src={slide.image} width="100%" />
                            </a>
                        </div>
                    );
                })}
            </Slider>
        );
    }

    render () {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item active" aria-current="page">ダッシュボード</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main" onMouseOver={this.onHoverTooltip}>
                    {/* <div className="mx-3 mb-1">
                        {this._renderTopSliders()}
                    </div>
                    <div class="mb-5">
                        <p class="text-danger text-center h4">広告掲載をご希望の法人様募集中！！</p>
                    </div> */}
                    <div className="row mb-5">
                        <div className="col-sm-11 container">
                            <div className="row justify-content-between justify-content-md-start">
                                <div className="col-5 col-md-3 pr-0 pl-0 pr-md-3 pl-md-3 mb-5 ml-3 ml-md-0">
                                    <div className="card bg-pink text-white">
                                        <a onClick={this.fireRedirect} href="/houjin/jobs">
                                            <div className="pt-5 pb-5 text-center text-white">
                                                <i className="material-icons md-48 mx-auto d-block mb-3">assignment</i>
                                                <strong className="card-title h3">依頼一覧</strong>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-5 col-md-3 pr-0 pl-0 pr-md-3 pl-md-3 mb-5 mr-3 mr-md-0">
                                    <div class="card bg-orange text-white">
                                        <a onClick={this.fireRedirect} href="/houjin/jobs/create">
                                            <div className="pt-5 pb-5 text-center">
                                                <i className="material-icons md-48 mx-auto d-block mb-3">edit</i>
                                                <strong className="card-title h3">依頼作成</strong>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-5 col-md-3 pr-0 pl-0 pr-md-3 pl-md-3 mb-5 ml-3 mr-3 ml-md-0 mr-md-0 d-none d-md-block">
                                    <div className="card">
                                        <a onClick={this.fireRedirect} href="/houjin/jobapplys">
                                            <span className="notification_job_apply">
                                                {this.state.numberRedApply != 0 ?
                                                    <span className="notification_filting notification_is_not_new" data-toggle="tooltip" data-placement="bottom" title="新応募数">{this.state.numberRedApply}</span>
                                                    : ''
                                                }
                                                {this.state.numberWaitForEvalApply != 0 ?
                                                    <span className="notification_filting notification_is_must_evaluate" data-toggle="tooltip" data-placement="bottom" title="評価待ちの応募数">{this.state.numberWaitForEvalApply}</span>
                                                    : ''
                                                }
                                                {this.state.numberNewMsgApply != 0 ?
                                                    <span className="notification_filting notification_is_new_msg" data-toggle="tooltip" data-placement="bottom" title="新メッセージがある応募数">{this.state.numberNewMsgApply}</span>
                                                    : ''
                                                }
                                            </span>
                                            <div className="pt-5 pb-5 text-center bg-cyan text-white">
                                                <i className="material-icons md-48 mx-auto d-block mb-3">assignment_ind</i>
                                                <strong className="card-title h3">応募一覧</strong>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-5 col-md-3 pr-0 pl-0 pr-md-3 pl-md-3 mb-5 ml-3 mr-3 ml-md-0 mr-md-0">
                                    <div className="card bg-purple text-white">
                                        <a onClick={this.fireRedirect} href="/houjin/messages">
                                        {this.state.numberNewMsgApply != 0 ?
                                            <span class="notification_job_apply">
                                                <span class="notification_filting bg-danger" data-toggle="tooltip"
                                                    data-placement="bottom" title=""
                                                    data-original-title="新着メッセージ">{this.state.numberNewMsgApply}</span>
                                            </span> : ''
                                        }
                                            <div className="pt-5 pb-5 text-center">
                                                <i className="material-icons md-48 mx-auto d-block mb-3">message</i>
                                                <strong className="card-title h3">コメント履歴</strong>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <div className="row mb-5">
                        <div className="col-sm-12">
                            <div className="card-deck">
                                <div className="card bg-orange text-white">
                                    <a onClick={this.fireRedirect} href="/houjin/jobs/create">
                                        <div className="card-body p-5 text-center">
                                            <i className="material-icons md-48 mx-auto d-block mb-3">edit</i>
                                            <strong className="card-title">依頼作成</strong>
                                            <p className="mb-0">新規の依頼作成を行います</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="col" />
                                <div className="col" />
                            </div>
                        </div>
                    </div> */}
                </main>
            </div>
        );
    }
}
export default Home;
